module.exports = __webpack_public_path__ + "static/media/p2.a7c4a2fb.jpg";